import { Plugins } from 'ops2clientlibrary'
import PageWrapper from '../pages/components/GPageWrapper'

export default {
  install (Vue) {
    Vue.use(Plugins.Components)
    Vue.component(PageWrapper.name, PageWrapper)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globalComponents.js